__turbopack_context__.v({
  "btn": "NpDdRq_btn",
  "btnFooter": "NpDdRq_btnFooter",
  "cardArticle": "NpDdRq_cardArticle",
  "cards": "NpDdRq_cards",
  "content": "NpDdRq_content",
  "custom-dot-list-style": "NpDdRq_custom-dot-list-style",
  "headContact": "NpDdRq_headContact",
  "headkutip": "NpDdRq_headkutip",
  "p": "NpDdRq_p",
  "page-body-wrap": "NpDdRq_page-body-wrap",
  "pagehero": "NpDdRq_pagehero",
  "paragraph": "NpDdRq_paragraph",
  "paragraph-content": "NpDdRq_paragraph-content",
  "phonecontent": "NpDdRq_phonecontent",
  "react-multi-carousel-dot": "NpDdRq_react-multi-carousel-dot",
  "react-multi-carousel-dot--active": "NpDdRq_react-multi-carousel-dot--active",
  "react-multi-carousel-list": "NpDdRq_react-multi-carousel-list",
  "slider": "NpDdRq_slider",
  "store": "NpDdRq_store",
  "t": "NpDdRq_t",
  "title": "NpDdRq_title",
  "wrap-container": "NpDdRq_wrap-container",
  "wrap-content": "NpDdRq_wrap-content",
});
